import React from 'react';
import { Link } from 'react-router-dom';
import APP_CONFIG from '../config/appConfig';

const BlogCard = ({ blog, isEditMode = false, onEdit, onDelete, onReadMore }) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const truncateText = (text, maxLength = 120) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  const getImageUrl = (image) => {
    if (!image) return null;
    if (image.startsWith('http')) return image;
    const baseServerUrl = APP_CONFIG.getBaseServerUrl();
    return `${baseServerUrl}${image}`;
  };

  return (
    <article className="bg-gray-800 rounded-lg border-2 border-gray-400 overflow-hidden hover:shadow-2xl transition-all duration-300 max-w-sm mx-auto" style={{ boxShadow: '0 0 15px rgba(156, 163, 175, 0.5), 0 0 30px rgba(156, 163, 175, 0.3)' }}>
      <div className="aspect-w-16 aspect-h-9">
        {getImageUrl(blog.image) ? (
          <img
            src={getImageUrl(blog.image)}
            alt={blog.title}
            className="w-full h-40 object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div 
          className={`w-full h-40 flex items-center justify-center bg-gray-700 ${getImageUrl(blog.image) ? 'hidden' : 'flex'}`}
        >
          <div className="text-center text-gray-300">
            <svg className="w-12 h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <p className="text-sm font-medium">Blog Post</p>
          </div>
        </div>
      </div>
      <div className="p-4 bg-gray-800">
        <div className="flex items-center text-xs text-white mb-2">
          <span>{formatDate(blog.createdAt)}</span>
          <span className="mx-2">•</span>
          <span className="bg-gray-500 text-white px-2 py-1 rounded-full text-xs">{blog.category}</span>
        </div>
        <h3 className="text-base font-semibold text-white mb-2 line-clamp-2 max-w-full">
          {blog.title}
        </h3>
        <p className="text-xs text-white mb-3 line-clamp-3 max-w-full">{truncateText(blog.excerpt, 100)}</p>
        {isEditMode ? (
          <div className="flex space-x-2">
            <button
              onClick={() => onEdit(blog)}
              className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
            >
              Edit
            </button>
            <button
              onClick={() => onDelete(blog.id)}
              className="flex-1 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-sm"
            >
              Delete
            </button>
          </div>
        ) : (
          <button
            onClick={() => onReadMore && onReadMore(blog)}
            className="inline-flex items-center text-sm text-white hover:text-gray-300 font-medium cursor-pointer"
          >
            Read More
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}
      </div>
    </article>
  );
};

export default BlogCard;
